module.exports = __webpack_public_path__ + "static/media/filter-icon.e8832bf4.svg";